// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CircleSwitch.css */

.circle-switch, .circle-switch-n-a {
  position: relative;
	display: flex;
	margin: 0px;
	height: 45px;
	min-height: 45px;
	width: 45px;
	min-width: 45px;
	outline: none;
	border: var(--tg-theme-button-color, dodgerblue) solid 2px;
	border-radius: 35%;
	background: var(--tg-theme-bg-color-transparent);
	/* background: rgba(var(--tg-theme-bg-color), 0.4);; */
	color: var(--tg-theme-button-text-color, white);
	justify-content: center;
	align-items: center;
	transition: background 100ms;
	-webkit-user-select: auto;
	        user-select: auto;
  z-index: 200;
}

.circle-switch-n-a {
	border: var(--tg-theme-hint-color, rgb(163, 163, 163)) solid 2px;
	opacity: 0.8;
}

.circle-switch-menu-indicator, .circle-switch-menu-indicator-n-a {
  position: absolute;
  top: 8%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 17px;
  height: 2.2px;
  background-color: var(--tg-theme-button-color, dodgerblue);
  border-radius: 1.7px;
  z-index: 300;
}

.circle-switch-menu-indicator-n-a {
  background-color: var(--tg-theme-hint-color, rgb(163, 163, 163));
	opacity: 0.8;
}

.circle-switch-menu-indicator.active,
.circle-switch-menu-indicator:active  {
  background-color: var(--tg-theme-button-text-color, white);
  /* height: 2.4px; */
}



.circle-switch .svg, .circle-switch-n-a .svg  {
	color: var(--tg-theme-button-color, dodgerblue);
	transition: color 100ms;
  pointer-events: none; /* Игнорировать события мыши на SVG */
}

.circle-switch-n-a .svg {
	color: var(--tg-theme-hint-color, rgb(163, 163, 163));
	opacity: 0.8;
}

.circle-switch.active,
.circle-switch:active 
{
	background: var(--tg-theme-button-color, dodgerblue);
}

.circle-switch-n-a.active,
.circle-switch-n-a:active 
{
	background: var(--tg-theme-hint-color, rgb(163, 163, 163));
	opacity: 0.8;
}

.circle-switch.active .svg,
.circle-switch:active .svg,
.circle-switch-n-a.active .svg,
.circle-switch-n-a:active .svg
 {
	color: var(--tg-theme-button-text-color, white);
}
`, "",{"version":3,"sources":["webpack://./src/components/board/tools/CircleSwitch/CircleSwitch.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,kBAAkB;CACnB,aAAa;CACb,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,aAAa;CACb,0DAA0D;CAC1D,kBAAkB;CAClB,gDAAgD;CAChD,sDAAsD;CACtD,+CAA+C;CAC/C,uBAAuB;CACvB,mBAAmB;CACnB,4BAA4B;CAC5B,yBAAiB;SAAjB,iBAAiB;EAChB,YAAY;AACd;;AAEA;CACC,gEAAgE;CAChE,YAAY;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,aAAa;EACb,0DAA0D;EAC1D,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gEAAgE;CACjE,YAAY;AACb;;AAEA;;EAEE,0DAA0D;EAC1D,mBAAmB;AACrB;;;;AAIA;CACC,+CAA+C;CAC/C,uBAAuB;EACtB,oBAAoB,EAAE,qCAAqC;AAC7D;;AAEA;CACC,qDAAqD;CACrD,YAAY;AACb;;AAEA;;;CAGC,oDAAoD;AACrD;;AAEA;;;CAGC,0DAA0D;CAC1D,YAAY;AACb;;AAEA;;;;;CAKC,+CAA+C;AAChD","sourcesContent":["/* CircleSwitch.css */\n\n.circle-switch, .circle-switch-n-a {\n  position: relative;\n\tdisplay: flex;\n\tmargin: 0px;\n\theight: 45px;\n\tmin-height: 45px;\n\twidth: 45px;\n\tmin-width: 45px;\n\toutline: none;\n\tborder: var(--tg-theme-button-color, dodgerblue) solid 2px;\n\tborder-radius: 35%;\n\tbackground: var(--tg-theme-bg-color-transparent);\n\t/* background: rgba(var(--tg-theme-bg-color), 0.4);; */\n\tcolor: var(--tg-theme-button-text-color, white);\n\tjustify-content: center;\n\talign-items: center;\n\ttransition: background 100ms;\n\tuser-select: auto;\n  z-index: 200;\n}\n\n.circle-switch-n-a {\n\tborder: var(--tg-theme-hint-color, rgb(163, 163, 163)) solid 2px;\n\topacity: 0.8;\n}\n\n.circle-switch-menu-indicator, .circle-switch-menu-indicator-n-a {\n  position: absolute;\n  top: 8%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 17px;\n  height: 2.2px;\n  background-color: var(--tg-theme-button-color, dodgerblue);\n  border-radius: 1.7px;\n  z-index: 300;\n}\n\n.circle-switch-menu-indicator-n-a {\n  background-color: var(--tg-theme-hint-color, rgb(163, 163, 163));\n\topacity: 0.8;\n}\n\n.circle-switch-menu-indicator.active,\n.circle-switch-menu-indicator:active  {\n  background-color: var(--tg-theme-button-text-color, white);\n  /* height: 2.4px; */\n}\n\n\n\n.circle-switch .svg, .circle-switch-n-a .svg  {\n\tcolor: var(--tg-theme-button-color, dodgerblue);\n\ttransition: color 100ms;\n  pointer-events: none; /* Игнорировать события мыши на SVG */\n}\n\n.circle-switch-n-a .svg {\n\tcolor: var(--tg-theme-hint-color, rgb(163, 163, 163));\n\topacity: 0.8;\n}\n\n.circle-switch.active,\n.circle-switch:active \n{\n\tbackground: var(--tg-theme-button-color, dodgerblue);\n}\n\n.circle-switch-n-a.active,\n.circle-switch-n-a:active \n{\n\tbackground: var(--tg-theme-hint-color, rgb(163, 163, 163));\n\topacity: 0.8;\n}\n\n.circle-switch.active .svg,\n.circle-switch:active .svg,\n.circle-switch-n-a.active .svg,\n.circle-switch-n-a:active .svg\n {\n\tcolor: var(--tg-theme-button-text-color, white);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
